import { useSelect } from "@chakra-ui/react";
import { notify } from "common/toastUtil";
import { validateAddAdmin } from "common/validation";
import React, { use, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateAppAdminOrAgent } from "services/userService";
import { updateAppAdminOrAgentThunk } from "slices/userSlice";
import { getUnassignedAppListThunk } from "slices/userSlice";
import { fetchAdminThunk } from "slices/userSlice";
import { resetSubmission } from "slices/userSlice";
import { addAppAdminOrAgentThunk } from "slices/userSlice";

export default function AddAdminModal({open, setOpen,singleData,setSingleData}) {

  const [form, setForm] = React.useState({
    email: "",
    name: "",
    role: "agent",
    appID: "",
  });
    const [errors, setErrors] = useState({
    email: "",
    name: "",
    role: "agent",
    appID: "",
    });
    const [isCancel, setIsCancel] = useState(false);
const dispatch = useDispatch();
const {data,error,status,unAssignedApp}=useSelector((state) => state.users);
const isEdit = Object.keys(singleData).length > 0;
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...form, [name]: value };
    setForm(updated);
       const fieldError = validateAddAdmin(updated,isEdit);
        setErrors({ ...errors, [name]: fieldError[name] ?? "" });
  };

  const handleSubmit = () => {
    const validationErrors = validateAddAdmin(form,isEdit);
     setErrors(validationErrors);
    const isValid = Object.values(validationErrors).every((x) => x === "")
    if (isValid) {
      if(isEdit){
      dispatch(updateAppAdminOrAgentThunk({
        ...form,
        id:singleData?._id
      }))
      }else{
        dispatch(addAppAdminOrAgentThunk(form))
      }
     
    }
  };
  useEffect(()=>{
if(status==="succeeded" && data?.status==201){
  setOpen(false);
  notify("success", data?.message)
  setForm({
    email: "",
    name: "",
    role: "agent",
    appID: "",
  });
  setErrors({
    email: "",
    name: "",
    role: "agent",
    appID: "",
  });
      dispatch(resetSubmission()); 
      dispatch(fetchAdminThunk())
       dispatch(getUnassignedAppListThunk())
   
}
if(error){
   notify("error", error)
}
  },[status,dispatch,error])
useEffect(()=>{
  if(singleData){
    setForm({
      email: singleData?.email || "",
      name: singleData?.name || "",
      role: singleData?.role || "agent",
      appID: singleData?.appID || "",
    });
  }
},[singleData])
useEffect(()=>{
     dispatch(getUnassignedAppListThunk())
},[])

  return (
    <>
  

      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 bg-[#0d0d0c99] "
          aria-modal="true"
          role="dialog"
        >
          <div className="bg-white dark:bg-navy-700 rounded-xl w-full max-w-md mx-4 p-6">
            <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-4">
              Create App Admin/Agent
            </h2>
            {/* Email */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Email*
              </label>
              <input
                name="email"
                type="email"
                value={form.email}
                placeholder="Enter email"
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.email && (
                <p className="text-red-500 text-sm mt-1">{errors.email}</p>)
              }
            </div>
         
            {/* Name */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Name*
              </label>
              <input
                name="name"
                type="text"
                  placeholder="Enter name"
                value={form.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {
                errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name}</p>)
              }
            </div>
            {/* Role */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Role*
              </label>
              <select
                name="role"
                value={form.role}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="agent">Agent</option>
                <option value="appAdmin">App Admin</option>
              </select>
            </div>
            {/* App ID (conditional) */}
            {form.role === "appAdmin" && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  App ID*
                </label>
                    <select
                name="appID"
                value={form.appID}
                onChange={handleChange}
                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">Select App</option>
                {unAssignedApp?.data?.length >0 && unAssignedApp?.data?.map((item,index)=>(
  <option value={item?.app_id}>{`${item?.app_id}  ${item?.app_name}`}</option>
                ))}
              
              </select>
                {
                  errors.appID && (
                  <p className="text-red-500 text-sm mt-1">{errors.appID}</p>)
                }
              </div>
            )}
            {/* Buttons */}
            <div className="flex justify-end space-x-3">
              <button
                onClick={() =>{
              setSingleData({})
                  setForm({
                    email: "",
                    password: "",
                    name: "",
                    role: "agent",
                    appID: "",
                  });
                  setErrors({
                    email: "",
                    password: "",
                    name: "",
                    role: "agent",
                    appID: "",
                  });
                      setOpen(false);
                }}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-600 rounded hover:bg-gray-300 dark:hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
